var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundVisual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a1aab2",
    d: "M4 21q-.825 0-1.413-.588T2 19V5q0-.825.588-1.413T4 3h16q.825 0 1.413.588T22 5v14q0 .825-.588 1.413T20 21H4Zm5-4q.425 0 .713-.288T10 16q0-.425-.288-.713T9 15H6q-.425 0-.713.288T5 16q0 .425.288.713T6 17h3Zm5.55-4.825l-.725-.725q-.3-.3-.7-.287t-.7.312q-.275.3-.288.7t.288.7L13.85 14.3q.3.3.7.3t.7-.3l3.55-3.55q.3-.3.3-.7t-.3-.7q-.3-.3-.713-.3t-.712.3l-2.825 2.825ZM9 13q.425 0 .713-.288T10 12q0-.425-.288-.713T9 11H6q-.425 0-.713.288T5 12q0 .425.288.713T6 13h3Zm0-4q.425 0 .713-.288T10 8q0-.425-.288-.713T9 7H6q-.425 0-.713.288T5 8q0 .425.288.713T6 9h3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundVisual);
export default __webpack_public_path__ + "static/media/round-visual.d61f0ccb.svg";
export { ForwardRef as ReactComponent };